export default {
  MODAL_SET: 'MODAL_SET',
  MODAL_UNSET: 'MODAL_UNSET',
  MODAL_ADVERT_SET: 'MODAL_ADVERT_SET',
};



// WEBPACK FOOTER //
// ./src/modules/shared/modal/actionTypes.js